import { render } from "./FileUpload.vue?vue&type=template&id=70929034"
import script from "./FileUpload.vue?vue&type=script&lang=js"
export * from "./FileUpload.vue?vue&type=script&lang=js"

import "./FileUpload.vue?vue&type=style&index=0&id=70929034&lang=css"
script.render = render

export default script